import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/lib/Option';

import CardHtmlConverter from './CardHtmlConverter';
import StudyStatConverter from './StudyStatConverter';

import { NextStep } from '../../model/domain/NextStep';
import { NextStepTO } from '../to/NextStepTO';

const toDomain = (to: NextStepTO): NextStep =>
  ({
    c: pipe(O.fromNullable(to.c), O.map(CardHtmlConverter.toDomain)),
    s: StudyStatConverter.toDomain(to.s),
    progress: to.progress,
    msg: to.msg,
    streak: to.streak,
    mode: to.mode,
  } as NextStep);

export default {
  toDomain,
};
